export class CapabilityDetail {
    releaseNumber: string;
    releaseDate: Date;
    capabilities: string;
    description: string;
    capitalCost: string;
    omCost: string;
    
    constructor() {
        this.releaseNumber = '';
        this.releaseDate = null;
        this.capabilities = '';
        this.description = '';
        this.capitalCost = null;
        this.omCost = null;
    }
    
    }